import AcPurchaseDetailsDetailsTab from './details/details';

export default {
  Details: AcPurchaseDetailsDetailsTab,
};
